import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          这是一个免费发布的个人网站
        </p>
        
      </header>
    </div>
  );
}

export default App;
